// extracted by mini-css-extract-plugin
export default {"flexDiv":"SpendControlsTab_flexDiv__uNPjI","controlBlock":"SpendControlsTab_controlBlock__+rXUn"};